import { useHistory } from "react-router-dom";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { useEffect } from "react";

const PendingApprovalCommentPage = () => {
  const { updateShowPendingApprovalCommentPage } = useBoard();
  const history = useHistory();
  useEffect(() => window.scrollTo(0, 0), []);

  const handleBackToBoardDetail = () => {
    updateShowPendingApprovalCommentPage(false);
  };

  const handleBackToCategoriesPage = () => {
    history.push("/message-board/categories");
  };

  return (
    <div className={`${STBoardDetail.container} ${STBoardDetail.wrapper}`}>
      <div className={STBoardDetail.board}>
        <div
          className={`${STBoardDetail.pendingApprovalCommentPage} ${STBoardDetail.wrapper}`}
        >
          <span className={`${STBoardDetail.pendingApprovalCommentPageTitle}`}>
            コメント申請完了
          </span>
          <span
            className={`${STBoardDetail.pendingApprovalCommentPageDescription}`}
          >
            {
              "コメントありがとうございます！\nただいま確認中ですので、公開まで少しだけお待ちください！"
            }
          </span>
          <div className={STBoardDetail.pendingApprovalCommentButtonGroup}>
            <button
              onClick={handleBackToBoardDetail}
              className={STBoardDetail.navigateButton}
            >
              コメントした投稿に戻る＞
            </button>
            <button
              onClick={handleBackToCategoriesPage}
              className={STBoardDetail.navigateButton}
            >
              掲示板Topページへ戻る＞
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalCommentPage;
